﻿/* 
Object:         Tabstrip
Description:    Ensures that the viewmode is set and the tabstrip will be refreshed every time. 
Used in:        Web Application main (global)
*/

/*---[ ESLint ]---*/
/*
    global translatedLabels
*/

window.tabstrip = function () {
    
    return {

        initialize: function () {

        },

        onContentLoad: function (event) {

            // Non-active tabs, discard all html elements. (cleanup).
            $(".k-tabstrip-content:not(.k-active)").html("");

            // Set viewmode new active tab in the tabstrip.
            viewmode.setTabstripViewMode(event);            

            // Initialize inputs onchange event handler.
            inputs.initialize(translatedLabels.getTitleDialogUnSavedChanges(), translatedLabels.getContentDialogUnSavedChanges());
        },

        onSelect: function (event) {

            // Yes Action Messagbox
            function yesAction() {

                const promise = new Promise((resolve, reject) => {

                    // Do some async operation
                    $('*').removeClass('k-overlay'); // remove all overlays
                    inputs.removeDirtyInput();       // remove dirty input

                    // call resolve to say all operations
                    resolve();
                });

                promise.then(function () {
                    // when the promise is resolved, execute click event of the tab intended to open.

                    $("#" + event.item.id).click();  // activate tab (prev selected) from the tabstrip.
                });
            }

            $('[data-role="popup"]').each(function (index, element) {
                kendo.destroy($(element));
                $(element).parent().remove();
            });

            $('[role="dialog"]').each(function (index, element) {
                kendo.destroy($(element));
                $(element).parent().remove();
            });

            // 
            inputs.checkDirtyInput(event, yesAction);

        }
    }

}();